const Style = {

  toggleWrap: 'flex justify-center mb-5',
  toggleGroup: 'inline-flex items-center bg-slate-100 rounded-full p-1',
  toggleBtn: 'px-4 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer text-slate-500 hover:text-slate-700',
  toggleActive: 'bg-white text-slate-900 shadow',
  saveBadge: 'ml-1.5 text-xs font-semibold text-sg-green',

  popularCard: 'border border-sg-blue',
  ribbonWrap: 'absolute top-2 right-2',

  name: 'font-semibold text-lg text-slate-800',
  subheading: 'text-xs text-slate-400 mt-0.5 mb-3',

  price: 'font-extrabold text-3xl text-slate-900 mt-1 mb-1',
  currency: 'text-lg font-semibold text-slate-500 mr-0.5',
  period: 'text-xs font-normal text-slate-400 ml-1',
  annualNote: 'text-xs text-slate-400 mb-2',

}

export default Style;
